export enum LicenseFeatureName {
  CARTOGRAPHY_FULL = "cartography_full",
  DATAVIZ_DEVICE = "dataviz_device",
  DASHBOARD_FULL = "dashboard_full",
  INTERFACES_THIRD_PARTY = "interfaces_third_party",
  CAMPAIGN_MANAGEMENT_STATIC = "campaign_management_static",
}
